import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "standart-top-margin"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "ESTIMATION EXPIRED", -1)
const _hoisted_4 = {
  class: "mn-meeting",
  style: {"text-align":"center"}
}
const _hoisted_5 = {
  style: {"font-size":"xx-large"},
  class: "bi bi-calendar-event"
}
const _hoisted_6 = { class: "standart-top-margin" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import { MeetingRmodel } from '@/app.context/workspace/Event'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel'
import { useAppContext } from '@/app/_tech'
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace'
import { Guid } from '@/lib'
import sys from '@/sys'



export default /*#__PURE__*/_defineComponent({
  __name: 'EventComponent',
  props: {
    person: {},
    level: {}
  },
  setup(__props: any) {


const model = __props

const context = useAppContext()

function onEventFinish(tid: Guid, minutes:number) {

    const p = model.person

    if (p) {

        //const timespan = event.minuteSpanToNow()

        eventResolve(tid, minutes)
    }
    else sys.warn(`/workspaces/person Current event finish - null person at cursor. Tid: ${tid}`)
}

function onEventCancel(tid: Guid) {

    const p = model.person

    if (p) {

        const timespan = 0;

        eventResolve(tid, timespan)
    }
    else sys.warn(`/workspaces/person Current event finish - null person at cursor. Tid: ${tid}`)
}


function eventResolve(tid: Guid, minutes: number) {

    const p = model.person

    if (p) {

        context.storages.workspace!.eventTimespanUpdate(p.workspace.wid, p.nid, tid, minutes)

        //p.event = null;
        //p.event_stopping = null
    }



}


return (_ctx: any,_cache: any) => {
  return (model.person.efforts != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.person.efforts.timespendings_Current, (effort, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (effort.objects.meeting != null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (effort.objects.meeting.expirated_estimated != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("strong", null, _toDisplayString(_unref(sys).time.format(effort.objects.meeting.expirated_estimated)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
                      [_vShow, effort != null]
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_unref(sys).time.format(effort.segment.timepoint)), 1),
                    _createElementVNode("p", null, _toDisplayString(effort.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (onEventFinish(effort.tid, effort.segment.minuteSpanToNow()))
                    }, "Finish", 8, _hoisted_7),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (onEventCancel(effort.tid))
                    }, "Skip", 8, _hoisted_8)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})